import createReducer from 'redux/createReducer';

import { initialState } from 'redux/modules/incentive-offer-propositions/state';
import getPropositions from './get-propositions';

export const actionTypeReducerMap = [...getPropositions()] as const;

export type PayloadMap = ReducerMapTupleToRecord<typeof actionTypeReducerMap>;
export default createReducer(initialState, actionTypeReducerMap);
